<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="col-md-12 manual_record">
          <div class="header row">
            <div class="left">
              <img src="@/assets/img/Group_10680.svg" />
            </div>

            <div class="left">
              <h4>{{ $t("text.bManualRec.rejectedEOD") }}</h4>
              <p></p>
            </div>
          </div>
          <br class="clear" />
          <div class="body row">
            <div class="col-md-12" style="padding: 0 !important">
              <div
                class="stepper-body row justify-content-around"
                v-show="!showLoader"
              >
                <div class="col-md-12 mt-3">
                  <ejs-grid
                    v-show="!showLoader"
                    ref="dataGrid"
                    :created="refreshGrid"
                    :allowPaging="true"
                    :allowSorting="true"
                    :pageSettings="pageSettings"
                    :toolbar="toolbar"
                    :searchSettings="search"
                    :locale="usedLang"
                  >
                    <e-columns>
                      <e-column
                        width="40"
                        field="index"
                        headerText="#"
                      ></e-column>
                      <e-column
                        field="date"
                        :format="formatOptions"
                        type="date"
                        width="190"
                        :headerText="$t('text.calendar.date')"
                      ></e-column>
                      <e-column
                        field="name"
                        width="180"
                        :headerText="$t('text.form.name')"
                      ></e-column>
                      <e-column
                        field="dataType"
                        width="180"
                        :headerText="$t('text.bManualRec.recordType')"
                      ></e-column>
                      <e-column
                        width="250"
                        :template="buttonsTemplate"
                        :headerText="$t('text.actionButtons.title')"
                      ></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>

              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import TableLoader from "@/components/tableLoader/index";
import Temp from "@/components/TableTemplates/rejectedRecord.vue";
import configObject from "@/config";
import { Page, Sort, Toolbar, Search, Resize } from "@syncfusion/ej2-vue-grids";

export default {
  name: "rejectedRecord",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, Resize],
  },
  created() {
    document.title = "Rejected Records:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Rejected Records:: ${branch.name} Retail Outlet`;
    });
  },
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getRejectedRecords();
        }
      }
    },
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      branch: {},
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      branchId: null,
      rejectedRecords: [],
      buttonsTemplate: function () {
        return {
          template: Temp,
        };
      },
    };
  },
  methods: {
    getRejectedRecords() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RejectedTransactions/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) =>
            a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0
          );

          let index = 0;
          response.data.forEach((element) => {
            element.index = ++index;
          });

          //this.rejectedRecords = response.data
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });

          this.showLoader = false;
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    convertThousand(request) {
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
